import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import ReportShell, { RC, dateInp, refreshBtn, excelBtn, thStyle } from './ReportShell';

function Ledger() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerId, setCustomer] = useState('');
    const { isAuthenticated, companyId,companyName, permissions, token, username, logout } = useAuth();
    const [reportGeneratedTime, setReportGeneratedTime] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchMasterType();
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, logout]);

    //  Master Type

    const [masterTypeOptions, setMasterTypeOptions] = useState([]);
    const [selectedMasterType, setSelectedMasterType] = useState("");
    const [selectedMaster, setSelectedMaster] = useState("");
    // const [selectedMasterType, setSelectedMasterType] = useState(null);

    const fetchMasterType = async () => {
        try {

            const mtid = 0; // Replace with the actual ID you want to fetch
            const response = await fetchData('MasterTypeApi', `/${mtid}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setMasterTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Master :', error);
        }
    };

    const [accountheadOptions, setAccountHeadOptions] = useState([]);
    const [selectedAccountHead, setSelectedAccountHead] = useState(null);
    const [AssetOptions, setAssetOptions] = useState([]);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");
    const [capitalOptions, setCapitalOptions] = useState([]);
    const [selectedCapital, setSelectedCapital] = useState("");
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState("");
    const [OtherOptions, setOtherOptions] = useState([]);
    const [selectedOther, setSelectedOther] = useState("");
    const [StaffOptions, setStaffOptions] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState("");
    const handleMasterTypeChange = async (selectedOption) => {
        setSelectedMasterType(selectedOption);
        setSelectedMaster(selectedOption.value);
        const selectedLabel = selectedOption.value;
        setDataItem([]);  // Clear previous data
        setSelectedMasterChild(''); // Clear selected master child
        try {
            // Call the fetch function based on selected master type
            const fetchFunctions = {
                1: fetchAccountHead,
                2: fetchAsset,
                3: fetchBank,
                4: fetchCapital,
                5: fetchSupplier,
                6: fetchOther,
                default: fetchStaff
            };

            const fetchFunction = fetchFunctions[selectedLabel] || fetchFunctions.default;
            fetchFunction();

        } catch (error) {
            console.error('Error fetching Master Child Details:', error);
        }
    };


    const fetchDataForMasterType = async (api, params) => {
        try {
            const response = await fetchData(api, `/${companyId}/${params}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.masterId,
                    label: item.name
                }));
                return options;
            }
        } catch (error) {
            console.error(`Error fetching ${api}:`, error);
        }
    };

    const fetchAccountHead = async () => {
        const options = await fetchDataForMasterType('AccountHeadApi', selectedMaster);
        setAccountHeadOptions(options);
    };

    const fetchAsset = async () => {
        const options = await fetchDataForMasterType('AssetsApi', selectedMaster);
        setAssetOptions(options);
    };

    const fetchBank = async () => {
        const options = await fetchDataForMasterType('BankApi', selectedMaster);
        setBankOptions(options);
    };

    const fetchCapital = async () => {
        const options = await fetchDataForMasterType('CapitalApi', selectedMaster);
        setCapitalOptions(options);
    };

    const fetchSupplier = async () => {
        const options = await fetchDataForMasterType('SupplierAndCustomerApi', selectedMaster);
        setSupplierOptions(options);
    };

    const fetchOther = async () => {
        const options = await fetchDataForMasterType('MasterApi', selectedMaster);
        setOtherOptions(options);
    };

    const fetchStaff = async () => {
        const options = await fetchDataForMasterType('StaffApi', selectedMaster);
        setStaffOptions(options);
    };

    useEffect(() => {
        if (selectedMaster && masterTypeOptions.length > 0) {
            const foundOption = masterTypeOptions.find(opt => opt.value === selectedMaster);
            if (foundOption) {
                handleMasterTypeChange(foundOption); // ✅ Pass full object
            }
        }
    }, [selectedMaster, masterTypeOptions]);


    const [selectedMasterChild, setSelectedMasterChild] = useState('');
    const [selectedMasterChildlabel, setSelectedMasterChildlabel] = useState('');

    const handleAccountHeadChange = (selectedOption) => {
        setSelectedAccountHead(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        // fetchLedgerData(selectedOption.value);
    };

    const handleAssetChange = async (selectedOption) => {
        setSelectedAsset(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        // fetchLedgerData(selectedMasterChild);
    };

    const handleBankChange = async (selectedOption) => {
        setSelectedBank(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        // fetchLedgerData(selectedMasterChild);
    };

    const handleCapitalChange = async (selectedOption) => {
        setSelectedCapital(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        // fetchLedgerData(selectedMasterChild);
    };


    const handleSupplierChange = async (selectedOption) => {
        setSelectedSupplier(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        //  fetchLedgerData(selectedMasterChild);
    };

    const handleOtherChange = async (selectedOption) => {
        setSelectedOther(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        // fetchLedgerData(selectedMasterChild);
    };

    const handleStaffChange = async (selectedOption) => {
        setSelectedStaff(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        // fetchLedgerData(selectedMasterChild);
    };


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const fetchTableData = async () => {
        const now = new Date();
        const formattedDateTime =
            String(now.getDate()).padStart(2, '0') + '-' +
            String(now.getMonth() + 1).padStart(2, '0') + '-' +
            now.getFullYear() + ' ' +
            now.toLocaleTimeString(); // e.g., 10:45:23 AM

        setReportGeneratedTime(formattedDateTime);

        setDataItem([])
        try {
            const masterChildValue = selectedMasterChild;
            const response = await fetchData('ReportApi', `/Ledger/${companyId}/${masterChildValue}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setDataItem(response.response_data);

            }
        } catch (error) {
            console.error('Error fetching Ledger Details:', error);
        }

    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${day}-${month}-${year}`;

        return formattedDate;
    };
    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Ledger');
        worksheet.views = [
            { state: 'frozen', xSplit: 0, ySplit: 2 }
        ];
        let bal = 0;

        const computeBalance = (data) => {
            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                if (data.debit) bal += Math.abs(data.debit);
                if (data.credit) bal -= Math.abs(data.credit);
            }

            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
            }
            return '';
        };

        const customerLabel = selectedMasterChildlabel || 'All Customers';
        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };

        // Header Title Row
        worksheet.mergeCells('A1:E1');
        const headerCell = worksheet.getCell('A1');
        headerCell.value = `${companyName} - Ledger for ${customerLabel} From: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime}`;
        headerCell.font = { bold: true, size: 10 };
        headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

        // Column Headers
        const headerRow = worksheet.addRow(['Date', 'Description', 'Debit', 'Credit', 'Balance']);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = thinBorder;
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' }, // Light green
            };
        });

        // Data Rows
        filteredDataItem.forEach((rowData) => {
            let rowValues;

            if (rowData.description1 === 'Opening Balance' || rowData.description1 === 'Closing Balance' || rowData.description1 === 'Total') {
                rowValues = [
                    '',
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    rowData.description1 === 'Opening Balance' ? computeBalance(rowData) : ''
                ];
            } else {
                rowValues = [
                    formatDateForInput(rowData.date1),
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    computeBalance(rowData)
                ];
            }

            const row = worksheet.addRow(rowValues);

            if (rowData.description1 === 'Closing Balance' || rowData.description1 === 'Total') {
                row.eachCell((cell) => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF4CCCC' }, // Light pink
                    };
                    cell.font = { bold: true };
                    cell.border = thinBorder;
                    cell.alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
                });
            } else {
                row.eachCell((cell, colNumber) => {
                    if ([3, 4, 5].includes(colNumber)) {
                        cell.alignment = { horizontal: 'right' };
                        cell.numFmt = '#,##0.00';
                    } else {
                        cell.alignment = { horizontal: 'left' };
                    }
                    cell.border = thinBorder;
                });
            }
        });

        worksheet.columns.forEach((column) => {
            column.width = 20;
        });

        // Export to file
        const buffer = await workbook.xlsx.writeBuffer();
        const sanitizedCustomerLabel = customerLabel.replace(/[^\w]/g, '_');
        saveAs(
            new Blob([buffer]),
            `Ledger_${sanitizedCustomerLabel}_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`
        );
    };


    let copbal = 0; // Cumulative opening balance for credit
    let dopbal = 0; // Cumulative opening balance for debit
    let bal = 0;    // Running balance

    const computeBalance = (data) => {

        if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
            // Add debit to balance
            if (data.debit) {
                bal += Math.abs(data.debit);
            }
            // Subtract credit from balance
            if (data.credit) {
                bal -= Math.abs(data.credit);
            }
        }

        // Return balance string with "Dr" or "Cr"
        if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
            return bal > 0 ? `${bal.toFixed(2)}  Dr` : `${Math.abs(bal).toFixed(2)}  Cr`;
        }
        return '';
    };
    // const handleExportExcel = () => {
    //     const excelData = [];
    //     let copbal = 0; // Cumulative opening balance for credit
    //     let dopbal = 0; // Cumulative opening balance for debit
    //     let bal = 0;    // Running balance

    //     // Helper function to compute balance
    //     const computeBalance = (data) => {
    //         // if (data.description1 === 'Opening Balance') {
    //         //     bal = 0; // Reset balance for opening balance
    //         // } else 
    //         if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //             // Add debit to balance
    //             if (data.debit) {
    //                 bal += Math.abs(data.debit);
    //             }
    //             // Subtract credit from balance
    //             if (data.credit) {
    //                 bal -= Math.abs(data.credit);
    //             }
    //         }

    //         // Return balance string with "Dr" or "Cr"
    //         //data.description1 !== 'Opening Balance' &&
    //         if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //             return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
    //         }
    //         return '';
    //     };



    //     const customerLabel = selectedMasterChildlabel || 'All Customers'; // Use selected label or default to 'All Customers'
    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;


    //     // Add header caption
    //     const headerCaption = [
    //         [`Ledger for  ${customerLabel} From : ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By : ${username}`]
    //     ];
    //     excelData.push(...headerCaption);

    //     // Add column headers
    //     const headerRow = ['Date', 'Description', 'Debit', 'Credit', 'Balance'];
    //     excelData.push(headerRow);

    //     // Add data rows
    //     filteredDataItem.forEach((rowData) => {
    //         const dataRow = [];
    //         if (rowData.description1 === 'Opening Balance') {
    //             // Display balances under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 computeBalance(rowData)
    //             );

    //         } else if (rowData.description1 === 'Closing Balance') {
    //             // Display Total directly under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 '' // No balance for Total rows
    //             );
    //         }

    //         else if (rowData.description1 === 'Total') {
    //             // Display Total directly under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 '' // No balance for Total rows
    //             );
    //         } else {
    //             // For regular rows
    //             dataRow.push(
    //                 formatDateForInput(rowData.date1), // Format the date
    //                 rowData.description1,
    //                 rowData.debit != null ? parseFloat(rowData.debit.toFixed(2)) : '',
    //                 rowData.credit != null ? parseFloat(rowData.credit.toFixed(2)) : '',
    //                 computeBalance(rowData) // Compute and add balance
    //             );
    //         }
    //         excelData.push(dataRow);
    //     });

    //     // Create a worksheet
    //     const worksheet = XLSX.utils.aoa_to_sheet(excelData);

    //     // Style the worksheet to right-align specific columns
    //     const columnIndexesToRightAlign = [2, 3, 4, 5]; // Debit, Credit, and Balance columns
    //     const range = XLSX.utils.decode_range(worksheet['!ref']);

    //     for (let row = 1; row <= range.e.r; row++) { // Start from row 1 (skip header)
    //         columnIndexesToRightAlign.forEach((colIndex) => {
    //             const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });
    //             if (worksheet[cellAddress]) {
    //                 worksheet[cellAddress].s = { alignment: { horizontal: 'right' } };
    //             }
    //         });
    //     }

    //     // Use XLSX library to create and download the Excel file

    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Ledger');

    //     // Filename sanitization for spaces and special characters
    //     const sanitizedCustomerLabel = customerLabel.replace(/[^\w]/g, '_');
    //     XLSX.writeFile(workbook, `Ledger_${sanitizedCustomerLabel}.xlsx`);
    // };




    // let copbal = 0; // Cumulative opening balance for credit
    // let dopbal = 0; // Cumulative opening balance for debit
    // let bal = 0;    // Running balance

    // const computeBalance = (data) => {

    //     if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //         // Add debit to balance
    //         if (data.debit) {
    //             bal += Math.abs(data.debit);
    //         }
    //         // Subtract credit from balance
    //         if (data.credit) {
    //             bal -= Math.abs(data.credit);
    //         }
    //     }

    //     // Return balance string with "Dr" or "Cr"
    //     if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //         return bal > 0 ? `${bal.toFixed(2)}  Dr` : `${Math.abs(bal).toFixed(2)}  Cr`;
    //     }
    //     return '';
    // };


    return (
        <ReportShell
            title="LEDGER"
            recordCount={filteredDataItem.length}
            filters={<>
                <span style={{ fontSize: '10px', color: RC.muted, marginRight: '4px' }}>From</span>
                <input type="date" value={fromDate} onChange={handleFromDateChange} style={{ ...dateInp, width: '130px' }} />
                <span style={{ fontSize: '10px', color: RC.muted, marginRight: '4px', marginLeft: '8px' }}>To</span>
                <input type="date" value={toDate} onChange={handleToDateChange} style={{ ...dateInp, width: '130px' }} />
                <div style={{ minWidth: 160 }}>
                    <Select
                        value={selectedMasterType}
                        onChange={handleMasterTypeChange}
                        options={masterTypeOptions}
                        placeholder="Master Type"
                        isSearchable
                        menuPortalTarget={document.body}
                        styles={{
                            control: (b) => ({ ...b, minHeight: 28, height: 28, fontSize: 12 }),
                            valueContainer: (b) => ({ ...b, height: 28, padding: '0 6px' }),
                            indicatorsContainer: (b) => ({ ...b, height: 28 }),
                            menuPortal: (b) => ({ ...b, zIndex: 2000 }),
                            option: (b) => ({ ...b, fontSize: 12, padding: '4px 8px' }),
                            menu: (b) => ({ ...b, fontSize: 12 }),
                        }}
                    />
                </div>
                {selectedMasterType && (
                    <div style={{ minWidth: 200 }}>
                        {selectedMasterType.value === 1 && <Select value={selectedAccountHead} onChange={handleAccountHeadChange} options={accountheadOptions} placeholder="Account Head" isSearchable menuPortalTarget={document.body} styles={{ control: (b) => ({ ...b, minHeight: 28, height: 28, fontSize: 12 }), valueContainer: (b) => ({ ...b, height: 28, padding: '0 6px' }), indicatorsContainer: (b) => ({ ...b, height: 28 }), menuPortal: (b) => ({ ...b, zIndex: 2000 }), option: (b) => ({ ...b, fontSize: 12, padding: '4px 8px' }), menu: (b) => ({ ...b, fontSize: 12 }) }} />}
                        {selectedMasterType.value === 2 && <Select value={selectedAsset} onChange={handleAssetChange} options={AssetOptions} placeholder="Asset" isSearchable menuPortalTarget={document.body} styles={{ control: (b) => ({ ...b, minHeight: 28, height: 28, fontSize: 12 }), valueContainer: (b) => ({ ...b, height: 28, padding: '0 6px' }), indicatorsContainer: (b) => ({ ...b, height: 28 }), menuPortal: (b) => ({ ...b, zIndex: 2000 }), option: (b) => ({ ...b, fontSize: 12, padding: '4px 8px' }), menu: (b) => ({ ...b, fontSize: 12 }) }} />}
                        {selectedMasterType.value === 3 && <Select value={selectedBank} onChange={handleBankChange} options={bankOptions} placeholder="Bank" isSearchable menuPortalTarget={document.body} styles={{ control: (b) => ({ ...b, minHeight: 28, height: 28, fontSize: 12 }), valueContainer: (b) => ({ ...b, height: 28, padding: '0 6px' }), indicatorsContainer: (b) => ({ ...b, height: 28 }), menuPortal: (b) => ({ ...b, zIndex: 2000 }), option: (b) => ({ ...b, fontSize: 12, padding: '4px 8px' }), menu: (b) => ({ ...b, fontSize: 12 }) }} />}
                        {selectedMasterType.value === 4 && <Select value={selectedCapital} onChange={handleCapitalChange} options={capitalOptions} placeholder="Capital" isSearchable menuPortalTarget={document.body} styles={{ control: (b) => ({ ...b, minHeight: 28, height: 28, fontSize: 12 }), valueContainer: (b) => ({ ...b, height: 28, padding: '0 6px' }), indicatorsContainer: (b) => ({ ...b, height: 28 }), menuPortal: (b) => ({ ...b, zIndex: 2000 }), option: (b) => ({ ...b, fontSize: 12, padding: '4px 8px' }), menu: (b) => ({ ...b, fontSize: 12 }) }} />}
                        {selectedMasterType.value === 5 && <Select value={selectedSupplier} onChange={handleSupplierChange} options={supplierOptions} placeholder="Supplier/Customer" isSearchable menuPortalTarget={document.body} styles={{ control: (b) => ({ ...b, minHeight: 28, height: 28, fontSize: 12 }), valueContainer: (b) => ({ ...b, height: 28, padding: '0 6px' }), indicatorsContainer: (b) => ({ ...b, height: 28 }), menuPortal: (b) => ({ ...b, zIndex: 2000 }), option: (b) => ({ ...b, fontSize: 12, padding: '4px 8px' }), menu: (b) => ({ ...b, fontSize: 12 }) }} />}
                        {selectedMasterType.value === 6 && <Select value={selectedOther} onChange={handleOtherChange} options={OtherOptions} placeholder="Other" isSearchable menuPortalTarget={document.body} styles={{ control: (b) => ({ ...b, minHeight: 28, height: 28, fontSize: 12 }), valueContainer: (b) => ({ ...b, height: 28, padding: '0 6px' }), indicatorsContainer: (b) => ({ ...b, height: 28 }), menuPortal: (b) => ({ ...b, zIndex: 2000 }), option: (b) => ({ ...b, fontSize: 12, padding: '4px 8px' }), menu: (b) => ({ ...b, fontSize: 12 }) }} />}
                        {selectedMasterType.value === 7 && <Select value={selectedStaff} onChange={handleStaffChange} options={StaffOptions} placeholder="Staff" isSearchable menuPortalTarget={document.body} styles={{ control: (b) => ({ ...b, minHeight: 28, height: 28, fontSize: 12 }), valueContainer: (b) => ({ ...b, height: 28, padding: '0 6px' }), indicatorsContainer: (b) => ({ ...b, height: 28 }), menuPortal: (b) => ({ ...b, zIndex: 2000 }), option: (b) => ({ ...b, fontSize: 12, padding: '4px 8px' }), menu: (b) => ({ ...b, fontSize: 12 }) }} />}
                    </div>
                )}
            </>}
            actions={<>
                <button onClick={fetchTableData} style={refreshBtn}>Refresh</button>
                <button onClick={handleExportExcel} style={excelBtn}>Excel</button>
            </>}
        >
            <TableContainer component={Paper}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            {[['Date','left'],['Description','left'],['Debit','right'],['Credit','right'],['Balance','right']].map(([col, align]) => (
                                <TableCell key={col} style={{ ...thStyle, textAlign: align }}>{col}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredDataItem.map((data, index) => {
                            const isSpecial = ['Opening Balance','Closing Balance','Total'].includes(data.description1);
                            const linkColor = (() => {
                                switch (data.tbl1) {
                                    case 'Sale': return 'darkgreen';
                                    case 'SaleReturn': return 'red';
                                    case 'Receipt UPI': case 'Receipt Cheque': case 'Receipt Cash': return '#604652';
                                    case 'JournalCustomer1': case 'JournalCustomer2': case 'JournalSupplier1': case 'JournalSupplier2': case 'JournalBank1': case 'JournalBank': case 'JournalAccountHead': return 'darkmagenta';
                                    case 'Payment Cash': case 'Payment Cheque': case 'Payment UPI': return 'darkviolet';
                                    case 'Purchase': return 'darkcyan';
                                    case 'PurchaseReturn': return 'red';
                                    default: return 'inherit';
                                }
                            })();
                            const linkHref = (() => {
                                switch (data.tbl1) {
                                    case 'Sale': return `/SaleDetails/${data.id}`;
                                    case 'SaleReturn': return `/SaleReturnDetails/${data.id}`;
                                    case 'Receipt UPI': case 'Receipt Cheque': case 'Receipt Cash': return `/ReceiptDetails/${data.id}`;
                                    case 'JournalCustomer1': case 'JournalCustomer2': case 'JournalSupplier1': case 'JournalSupplier2': case 'JournalBank1': case 'JournalBank': case 'JournalAccountHead': return `/JournalEntryDetails/${data.id}`;
                                    case 'Payment Cash': case 'Payment Cheque': case 'Payment UPI': return `/PaymentDetails/${data.id}`;
                                    case 'Purchase': return `/PurchaseDetails/${data.id}`;
                                    case 'PurchaseReturn': return `/PurchaseReturnDetails/${data.id}`;
                                    default: return null;
                                }
                            })();
                            return (
                                <TableRow key={data.id || index} sx={{
                                    backgroundColor: isSpecial ? '#f0f4f4' : index % 2 === 0 ? '#fdfdfd' : '#f7fdfc',
                                    '&:hover': { backgroundColor: 'rgba(45,212,191,0.06)' },
                                }}>
                                    <TableCell sx={{ fontSize: '12px', padding: '5px 8px', fontWeight: isSpecial ? 700 : 400 }}>
                                        {isSpecial ? '' : formatDate(data.date1)}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '12px', padding: '5px 8px', fontWeight: isSpecial ? 700 : 400 }}>
                                        {linkHref ? <a href={linkHref} target="_blank" rel="noopener noreferrer" style={{ color: linkColor }}>{data.description1}</a> : data.description1}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right', fontWeight: isSpecial ? 700 : 400 }}>
                                        {data.debit != null ? data.debit.toFixed(2) : ''}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right', fontWeight: isSpecial ? 700 : 400 }}>
                                        {data.credit != null ? data.credit.toFixed(2) : ''}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right', fontWeight: 700 }}>
                                        {computeBalance(data)}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </ReportShell>
    );
}

export default Ledger;
